export default "__VITE_ASSET__Jx$pYkpS__"